// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Album__container-a01823 {
  overflow: hidden;
  width: var(--message-bubble-max-width);
  max-width: 100%;
  background-color: inherit;
}

.Album__bubble-fcc6c7 {
  max-width: var(--message-bubble-max-width);
}

.Album__row-eaed2c {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  max-width: 100%;
  margin-bottom: 2px;
  background-color: inherit;
}

.Album__row-eaed2c:last-child {
  margin-bottom: 0;
}

.Album__item-container-afcdca {
  margin-inline-end: 2px;
  position: relative;
  background-color: inherit;
}

.Album__item-container-afcdca:last-child {
  margin-inline-end: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Album/Album.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  width: var(--message-bubble-max-width);\n  max-width: 100%;\n  background-color: inherit;\n}\n\n.bubble {\n  max-width: var(--message-bubble-max-width);\n}\n\n.row {\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  max-width: 100%;\n  margin-bottom: 2px;\n  background-color: inherit;\n}\n\n.row:last-child {\n  margin-bottom: 0;\n}\n\n.item-container {\n  margin-inline-end: 2px;\n  position: relative;\n  background-color: inherit;\n}\n\n.item-container:last-child {\n  margin-inline-end: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Album__container-a01823`,
	"bubble": `Album__bubble-fcc6c7`,
	"row": `Album__row-eaed2c`,
	"item-container": `Album__item-container-afcdca`,
	"itemContainer": `Album__item-container-afcdca`
};
module.exports = ___CSS_LOADER_EXPORT___;
